<template>
  <div class="mb-4">
    <table class="full-width">
      <tbody>
        <tr>
          <td>{{ fullName(job.customer) }}</td>
        </tr>
        <tr>
          <td>{{ fullAddress(job.address) }}</td>
        </tr>
        <tr>
          <td>Revenue: {{ dollars(revenue) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getProperty } from "@/lib/helpers.js";

export default {
  computed: {
    ...mapState({
      job: "job",
      revenue({ job }) {
        if (!getProperty(job, "invoice")) {
          return null;
        }
        const { invoice } = job;
        return (
          invoice.financials.total_cents - invoice.financials.sales_tax_cents
        );
      }
    })
  }
};
</script>

<style lang="scss" scoped>
table {
  tr {
    td {
      font-size: 0.9rem;
      padding-right: 5px;
      line-height: 18px;
      &:last-of-type {
        width: 100%;
      }
    }
  }
}
</style>
